module.exports = __webpack_public_path__ + "img/touKui2.042d4853.png";